module.exports = __webpack_public_path__ + "media/site_templates/www.doorinstallation.company/images/splash-eb5926fb2ed8e39094ff96c872e82e61.jpg";